<template>
    <v-data-table
        dense
        :headers="headers"
        :footer-props="footer"
        :items="data"
        :loading="loading"
        :server-items-length="length"
        :options="options"
        @update:options="updateOptions"
    >
    <template v-slot:[`item.code`]="{item}">
        <v-btn icon @click="handleClickRow(item)" v-if="hasPermission(perm.debit_note.read)">
            <v-icon>mdi-magnify</v-icon>
        </v-btn>
        {{ item.code }}
    </template>

    <template v-slot:[`item.amount`]="{item}">
        {{formatMoney(item.amount, item.currency_abbreviation)}}
    </template>

    <template v-slot:[`item.state`]="{item}">
        <PStatus :state="item.state"/>
    </template>

    </v-data-table>
</template>

<script>
import permissions from './../../data/permissions';
import { mapActions, mapGetters } from 'vuex';
import { formatMoney } from 'accounting';
import PStatus from './../common/PStatus';

export default {
    name: "DebitNoteList",
    components: {
        PStatus
    },
    data() {
        return {
            footer: {
                'items-per-page-options': [10, 25, 50, 100]
            },
            headers: [
                { text: "Code", value: "code" },
                { text: "Date", value: "date" },
                { text: "Supplier", value: "supplier" },
                { text: "Amount", value: "amount"},
                { text: "Created By", value: "created_by" },
                { text: "State", value: "state"},
            ],
            perm: permissions
        }
    },
    computed: {
        ...mapGetters({
            options: "purchase/debitNote/options",
            loading: "purchase/debitNote/loading",
            length: "purchase/debitNote/length",
            data: "purchase/debitNote/list",
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions({
            updateOptions: "purchase/debitNote/updateOptions"
        }),
        handleClickRow(item) {
            this.$router.push({name: "DebitNoteDisplay", params: {id: item.id}})
        },
        formatMoney(amount, currency) {
            return formatMoney(amount, {
                symbol: currency,
                format: "%s %v"
            })
        }
    }
}
</script>

<style>
</style>